export const API = {
  GET_BOOKING_SLOTS: () => `booking/getBookingSlots`,
  CALCULATE_SHOP_PRICING: () => `booking/shop/calculatePricing`,
  UPLOAD_IMAGE: () => `upload`,
  GET_DISCOUNT: () => `user/coupon/validateCoupon`,
  CREATE_SHOP_BOOKING: () => `booking/shop/shopDetaling`,
  CREATE_MOBILE_BOOKING: () => `booking/mobile/mobileDetaling`,
  CONNECT_SERVER: () => `/`,
}

export const BOOKING_API = {
  GET_VEHICLE_OPTIONS: () => "public/getServiceOptions",
  GET_SERVICe_OPTIONS: () => "public/getServiceDescription",
  GET_BOOKING_SLOTS: () => "public/getBookingSlots",
  CREATE_BOOKING: () => "public/createGuestBookingOrder",
  VIEW_BOOKING: (id) => `public/getBookingTrackingStatus/${id}`,
}

export const GIFTCARD_API = {
  PURCHASE_GIFTCARD: () => "public/purchaseGiftCard",
  VIEW_GIFTCARD: (id) => `public/getGiftCardDetails/${id}`,
}